import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { callApi, callApiSuccess, callApiFailure } from './actions';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ReduxApiHandlerService } from '../service/state-api-handler.service';

@Injectable()
export class ApiEffects {
  constructor(private actions$: Actions, private api: ReduxApiHandlerService) {}

  callApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(callApi),
      mergeMap(({ method, endpoint, payload, key }) =>
        this.api.callApi(method, endpoint, payload).pipe(
          map((res: any) => {
            const parsedData = Array.isArray(res.body)
              ? { data: res.body, total: res.body.length }
              : res.body?.data
              ? { data: res.body.data, total: res.body.total || res.body.data.length }
              : { data: res.body, total: 0 };
            return callApiSuccess({ key: key || endpoint, data: parsedData });
          }),
          catchError((error) => of(callApiFailure({ key: key || endpoint, error })))
        )
      )
    )
  );
}
